import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { BodyText, Div, Flex, Title } from '@gaiads/telia-react-component-library';

import { User } from '../../../types';

type UsersListHeaderProps = {
  users: User[];
};

const UsersListHeader: FunctionComponent<UsersListHeaderProps> = ({ users }) => {
  const { t } = useTranslation('onboarding');

  return (
    <Flex spaceBetween>
      <Div margin={{ bottom: 'lg' }}>
        <Flex>
          <Title size={'sm'}>{t('userPage.importHeader.title')}</Title>
          <BodyText margin={{ top: 'xxs', left: 'sm' }} color={'purple500'}>
            {users.length ? `${users.length} ${t('userPage.importHeader.count')}` : t('userPage.importHeader.zeroCount')}
          </BodyText>
        </Flex>
      </Div>
    </Flex>
  );
};

export default UsersListHeader;
